import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { useEffectOnce, usePathParam, useViewport } from '@chilecompra/react-kit'
import { Breadcrumb, Breadcrumbs, Skeleton, Toast, Typography } from '@chilecompra/react-kit/components'
import { onGetBasicSellerInformationThunk } from '../BasicSellerInformationSection/BasicSellerInformationSection.actions'
import { Column, Navigation, Root } from './SanctionHeader.styles'
import { useAuthorization } from '../AuthorizationProvider/AuthorizationProvider.hooks'
import { USER_TYPE } from '../../config/settings/constant'
import useReCaptcha from '../../modules/hooks/reCaptcha'

/**
 * The Sanction Header's container.
 */
const SanctionHeader = ({ breadcrumbs }) => {
  const dispatch = useDispatch()

  const { userType } = useAuthorization()
  const { executeReCaptcha } = useReCaptcha()
  const {
    size: { isUpToMedium }
  } = useViewport()
  const dni = usePathParam('rut')
  const sanctionID = usePathParam('id')
  const { error: sellerError, loading, orgLegalName } = useSelector(state => state.basicSellerInformation)

  useEffectOnce(() => {
    if (isNaN(sanctionID) || !loading) return
    if (userType === USER_TYPE.PUBLIC) {
      const executeAll = async () => {
        await executeReCaptcha({ action: 'publicInfo' })
        dispatch(onGetBasicSellerInformationThunk({ dni }))
      }
      executeAll()
    } else {
      const executeAll = () => {
        dispatch(onGetBasicSellerInformationThunk({ dni }))
      }
      executeAll()
    }
  })

  return (
    <Root width={isUpToMedium ? '90%' : '100%'}>
      {isUpToMedium && (
        <Navigation>
          <Breadcrumbs>
            {breadcrumbs.map((breadcrumb, index) =>
              breadcrumb.link ? (
                breadcrumb.isExternal ? (
                  <Breadcrumb
                    key={`breadcrumb-link-${index}`}
                    target="_top"
                    to={breadcrumb.link}
                    type="external"
                    variant="link"
                    onClick={breadcrumb.onClick || undefined}
                  >
                    {breadcrumb.text}
                  </Breadcrumb>
                ) : (
                  <Breadcrumb key={`breadcrumb-link-${index}`} to={breadcrumb.link} variant="link">
                    {breadcrumb.text}
                  </Breadcrumb>
                )
              ) : (
                <Breadcrumb key={`breadcrumb-text-${index}`} variant="text">
                  {breadcrumb.text}
                </Breadcrumb>
              )
            )}
          </Breadcrumbs>
        </Navigation>
      )}

      <Typography fontWeight="bold" margin="2.3rem 0 0.2rem" noWrap={isUpToMedium} variant="h2">
        {`${isNaN(sanctionID) ? 'Registrar' : 'Detalle'} sanción por incumplimiento a ${orgLegalName}`}
        {loading && <Skeleton width={300} />}
      </Typography>

      {sellerError && (
        <Column item xs={12} sm={12} md={10} padding={isUpToMedium ? '0 27px 27px 0' : '0'}>
          <Toast margin="26px 0 0" severity="error">
            El proveedor que buscas no se encuentra inscrito en Mercado Público. Intenta con otra palabra clave u otro
            criterio de búsqueda.
          </Toast>
        </Column>
      )}
    </Root>
  )
}

SanctionHeader.defaultProps = {
  breadcrumbs: []
}

SanctionHeader.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      isExternal: PropTypes.bool,
      link: PropTypes.string,
      text: PropTypes.string.isRequired
    })
  ).isRequired
}

export default SanctionHeader
